export default "__VITE_ASSET__BPw4AQXa__"